import { createContext, useCallback, useContext, useState } from 'react'

export const AppContext = createContext()

import React from 'react'
import { replaceAll } from '../services/common'

export const AppProvider = ({ children }) => {
    const [selectedValue, setSelectedValue] = useState([])
    const [selectedCase, setSelectedCase] = useState([])
    const [checked, setChecked] = useState([])
    const [validateSelection, setValidateSelection] = useState(false)
    const [viewGeneralInformation, setViewGeneralInformation] = useState(false)
    const [helpModal, setHelpModal] = useState(false)
    const [valueLocation, setValueLocation] = useState({})
    const [attributesGuidedResearch, setAttributesGuidedResearch] = useState({})
    const [identifier, setIdentifier] = useState(null)
    const [type, setType] = useState(null)

    const constructName = useCallback((title) => {
        if (title) {
            const name = replaceAll(title, ' ', '-')
            return `quiz-${name}`
        }
    }, [])

    const constructAffectTrueValue = useCallback((child) => {
        const affectTrue = child?.attributes?.si_selectionne?.affecteVrai
        return affectTrue
    }, [])

    return (
        <AppContext.Provider
            value={{
                type,
                setType,
                identifier,
                setIdentifier,
                attributesGuidedResearch,
                setAttributesGuidedResearch,
                valueLocation,
                setValueLocation,
                selectedCase,
                setSelectedCase,
                selectedValue,
                setSelectedValue,
                setChecked,
                checked,
                validateSelection,
                setValidateSelection,
                viewGeneralInformation,
                setViewGeneralInformation,
                constructName,
                constructAffectTrueValue,
                helpModal,
                setHelpModal,
            }}
        >
            {children}
        </AppContext.Provider>
    )
}

export const useApp = () => useContext(AppContext)
